export default {
  add_items: 'Adicionar artigos',
  remove_items: 'Remover artigos',
  place_order: 'Fazer encomenda',
  proceed_to_payment: 'Continuar para o pagamento',
  go_to_menu: 'Ir para o menu',

  toasts: {
    input_errors_found: 'Existem alguns problemas com as informações da sua encomenda',
  },

  error_messages: {
    internal_error: {
      title: 'Encomenda sem sucesso 😔',
      description:
        'Infelizmente, ocorreu um problema inesperado com a sua encomenda. A nossa equipa técnica já está a trabalhar nisso 🛠️.',
    },
  },
};
